/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

(function() {
  if (window.__boh20PlanRefresh || !/^\/products\/bo-h2o(?:\/|$)/.test(window.location.pathname)) return;
  window.__boh20PlanRefresh = true;

  var previousUpcartSkipHandler = window.upcartShouldSkipAddToCart;
  window.upcartShouldSkipAddToCart = function(request) {
    var requestUrl = typeof request === 'string' ? request : request && request.url || '';
    if (/boh20_defer_upcart=1/.test(requestUrl)) return true;
    return typeof previousUpcartSkipHandler === 'function'
      ? previousUpcartSkipHandler.apply(this, arguments)
      : false;
  };

  var nativeFetch = window.fetch.bind(window);
  var planMapPromise;

  function findPlan(product, name) {
    var groups = product && product.selling_plan_groups || [];
    for (var groupIndex = 0; groupIndex < groups.length; groupIndex += 1) {
      var plans = groups[groupIndex].selling_plans || [];
      for (var planIndex = 0; planIndex < plans.length; planIndex += 1) {
        if (plans[planIndex].name === name) return plans[planIndex].id;
      }
    }
    return 0;
  }

  function loadPlanMap() {
    if (planMapPromise) return planMapPromise;

    var cacheKey = Date.now();
    planMapPromise = Promise.all([
      nativeFetch('/products/bo-h2o.js?plan_refresh=' + cacheKey, {
        headers: { Accept: 'application/json' }
      }).then(function(response) {
        if (!response.ok) throw new Error('Unable to load single-bag plans');
        return response.json();
      }),
      nativeFetch('/products/bo-h2o-3-bag-bundle.js?plan_refresh=' + cacheKey, {
        headers: { Accept: 'application/json' }
      }).then(function(response) {
        if (!response.ok) throw new Error('Unable to load bundle plans');
        return response.json();
      })
    ]).then(function(products) {
      return {
        monthly: findPlan(products[0], 'Monthly'),
        twoWeek: findPlan(products[0], 'Every 2 Weeks'),
        bundle45Day: findPlan(products[1], 'Every 45 Days')
      };
    });

    return planMapPromise;
  }

  function syncRenderedPlanIds(planMap) {
    var root = document.querySelector('[data-boh20-pdp]');
    if (!root) return;

    root.dataset.monthlyPlanId = String(planMap.monthly || 0);
    root.dataset.twoWeekPlanId = String(planMap.twoWeek || 0);
    root.dataset.bundle45DayPlanId = String(planMap.bundle45Day || 0);

    root.querySelectorAll('[data-boh20-single-frequency]').forEach(function(button) {
      button.dataset.planId = String(
        /2\s*weeks/i.test(button.textContent) ? planMap.twoWeek : planMap.monthly
      );
    });
  }

  function planForItem(item, planMap) {
    var offer = item && item.properties && item.properties.Offer || '';
    if (!/subscribe and save/i.test(offer)) return 0;
    if (/buy 2 get 1 free/i.test(offer)) return planMap.bundle45Day;
    if (/2\s*weeks/i.test(offer)) return planMap.twoWeek;
    return planMap.monthly;
  }

  window.fetch = function(input, init) {
    var url = typeof input === 'string' ? input : input && input.url || '';
    if (!/\/cart\/add\.js(?:\?|$)/.test(url) || !init || typeof init.body !== 'string') {
      return nativeFetch(input, init);
    }

    var payload;
    try {
      payload = JSON.parse(init.body);
    } catch (error) {
      return nativeFetch(input, init);
    }

    if (!payload || !Array.isArray(payload.items)) {
      return nativeFetch(input, init);
    }

    return loadPlanMap().then(function(planMap) {
      payload.items.forEach(function(item) {
        var planId = planForItem(item, planMap);
        if (planId) item.selling_plan = planId;
      });

      var refreshedInit = Object.assign({}, init, {
        body: JSON.stringify(payload)
      });
      return nativeFetch(input, refreshedInit);
    }).catch(function() {
      return nativeFetch(input, init);
    });
  };

  loadPlanMap().then(syncRenderedPlanIds).catch(function() {});
})();
